import React, { FC } from 'react';
import styles from '../TableOptions.module.scss';
import { VerticalAlignTopOutlined, VerticalAlignBottomOutlined } from '@ant-design/icons';
import { TABLE_STATUS } from '../../../../shared/Helpers';
import classNames from 'classnames';
type Props = {
  tableStatus: number;
  onSetStatusTable: (status: number) => void;
};

const UpDownArrows: FC<Props> = ({ tableStatus, onSetStatusTable }) => {
  const handlingSizeOfTable = (up: boolean) => {
    if (tableStatus !== TABLE_STATUS.NORMAL) {
      onSetStatusTable(TABLE_STATUS.NORMAL);
    } else {
      up ? onSetStatusTable(TABLE_STATUS.goUp(tableStatus)) : onSetStatusTable(TABLE_STATUS.goDown(tableStatus));
    }
  };
  return (
    <>
      <VerticalAlignTopOutlined
        className={classNames(styles.columnHeightIcon, { [styles.disabledIconsUpAndDown]: tableStatus == TABLE_STATUS.EXPANDED })}
        onClick={() => {
          handlingSizeOfTable(true);
        }}
      />

      <VerticalAlignBottomOutlined
        onClick={() => {
          handlingSizeOfTable(false);
        }}
        className={classNames(styles.columnHeightIcon, { [styles.disabledIconsUpAndDown]: tableStatus == TABLE_STATUS.HIDE })}
      />
    </>
  );
};

export default UpDownArrows;
